module.exports = new __parcel__URL__("banner.b8b88c77.png").toString();